import { render } from "./projects.vue?vue&type=template&id=63338994&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=63338994&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63338994"],['__file',"src/views/projects.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63338994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63338994', __exports__)) {
    api.reload('63338994', __exports__)
  }
  
  module.hot.accept("./projects.vue?vue&type=template&id=63338994&scoped=true", () => {
    api.rerender('63338994', render)
  })

}


export default __exports__